module.exports = __webpack_public_path__ + "img/check-animate.7be88362.gif";